import $ from "jquery";
import isotope from "isotope-layout";

// quick search regex
var qsRegex;

// vanilla JS
var $grid = document.querySelector(".search-agent-container__result");
if ($grid !== null) {
	var iso = new isotope($grid, {
		itemSelector: ".search-agent__wrapper",
		layoutMode: "fitRows",
		getSortData: {
			category: "[data-category]", // value of attribute
		},
		sortBy: ["original-order", "category"],
		//initLayout: false,
		filter: '[data-category="avdeling"]',
	});

	// use value of search field to filter
	var $quicksearch = $(".quicksearch").keyup(
		debounce(function () {
			qsRegex = new RegExp($quicksearch.val(), "gi");
			iso.arrange({
				filter: function () {
					const filterData = $(this).data('filter');
					let results = [];

					if (typeof filterData !== 'undefined') {
						const searchValues = Object.values(filterData);
						results = searchValues.filter(searchValue => {
							const value = typeof value === 'object' ? JSON.stringify(searchValue) : searchValue;
							return JSON.stringify(searchValue).match(qsRegex)
						});
					}

					return qsRegex ? results.length > 0 : true;
				},
			});
			var searchQuery = iso.getFilteredItemElements();
		}, 200)
	);

	// debounce so filtering doesn't happen every millisecond
	function debounce(fn, threshold) {
		var timeout;
		threshold = threshold || 100;
		return function debounced() {
			clearTimeout(timeout);
			var args = arguments;
			var _this = this;
			function delayed() {
				fn.apply(_this, args);
			}
			timeout = setTimeout(delayed, threshold);
		};
	}
}

$( document ).ready( function () {
	$( '.quicksearch' ).trigger( 'keyup' );
} );
